import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  url = 'http://api.nomiinoboo.com/'
  aUrl = 'http://api.nomiinoboo.com/api/shuaobao/';
  mUrl = 'http://api.nomiinoboo.com/media/';

  getHomeSlide = this.aUrl + 'GetHomeSlide';
  getBookSlide = this.aUrl + 'GetBookSlide';
  getNewBookList = this.aUrl + 'GetNewBookList';
  getBookDetails = this.aUrl + 'GetBookDetails?BookId=';
  getMuseumList = this.aUrl + 'GetMuseumList';
  getMTaxonomy = this.aUrl + 'GetMTaxonomy?TTitle=';
  getWriting = this.aUrl + 'GetWriting?TaxonomyId=';
  getSirisAjillagaList = this.aUrl + 'GetSirisAjillagaList?TaxonomyId=';
  getfameList= this.aUrl + 'GetfameList?TaxonomyId=';
  getBookList = this.aUrl + 'GetBookList?TaxonomyId=';
  getAuthorList = this.aUrl + 'GetAuthorList?TaxonomyId=';
  getIntroduce = this.aUrl + 'GetIntroduce';
  getMaster = this.aUrl + 'GetMaster';
  getbasheng = this.aUrl + 'Getbasheng';
  getfameDetailed = this.aUrl + 'GetfameDetailed?PeopleId=';
  getSRAJlGDetailed = this.aUrl + 'GetSRAJlGDetailed?Id=';
  getAuthorDetailed = this.aUrl + 'GetAuthorDetailed?PeopleId=';

  constructor(private http: HttpClient) { }

  GetHomeSlide(): Observable<any> {
    return this.http.get<any>(this.getHomeSlide);
  }
  GetBookSlide(): Observable<any> {
    return this.http.get<any>(this.getBookSlide);
  }
  GetBookDetails(id: string): Observable<any> {
    return this.http.get<any>(this.getBookDetails + id);
  }
  GetNewBookList(): Observable<any> {
    return this.http.get<any>(this.getNewBookList);
  }
  GetMuseumList(): Observable<any> {
    return this.http.get<any>(this.getMuseumList);
  }
  GetMTaxonomy(t: string): Observable<any> {
    return this.http.get<any>(this.getMTaxonomy + t);
  }
  GetSirisAjillagaList(id: string): Observable<any> {
    return this.http.get<any>(this.getSirisAjillagaList + id);
  }
  GetfameList(id: string, page: any, pageSize: any): Observable<any> {
    return this.http.get<any>(this.getfameList + id + '&startNumber=' + page + '&pageSize=' + pageSize);
  }
  GetBookList(id: any, page: any, pageSize: any): Observable<any> {
    return this.http.get<any>(this.getBookList + id + '&startNumber=' + page + '&pageSize=' + pageSize);
  }
  GetAuthorList(id: any, page: any, pageSize: any): Observable<any> {
    return this.http.get<any>(this.getAuthorList + id + '&startNumber=' + page + '&pageSize=' + pageSize);
  }
  GetIntroduce(): Observable<any> {
    return this.http.get<any>(this.getIntroduce);
  }
  GetMaster(): Observable<any> {
    return this.http.get<any>(this.getMaster);
  }
  GetWriting(id: any): Observable<any> {
    return this.http.get<any>(this.getWriting + id);
  }
  Getbasheng(): Observable<any> {
    return this.http.get<any>(this.getbasheng);
  }
  GetfameDetailed(id: any): Observable<any> {
    return this.http.get<any>(this.getfameDetailed + id);
  }
  GetSRAJlGDetailed(id: any): Observable<any> {
    return this.http.get<any>(this.getSRAJlGDetailed + id);
  } 
  GetAuthorDetailed(id: any): Observable<any> {
    return this.http.get<any>(this.getAuthorDetailed + id);
  }
}
